import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'mailstatsrequired', pure: false })
export class MailStatsRequiredPipe implements PipeTransform {
  transform(input: any[]): any[] {

    return input.filter(el => el.stats.length !== 0);
  }
}
